module.exports = "/layout/app/images/logo-signet.e388787a.svg";